import { useCallback } from 'react'
import { useAuth } from '../context/auth-context/AuthContext'

// check the token is expired
export const useCheckAndRefreshToken = () => {
  const { isTokenExpired, handleRefreshToken, user } = useAuth()

  const checkAndRefreshToken = useCallback(async (): Promise<string | null> => {
    if (isTokenExpired()) {
      await handleRefreshToken()
    }
    return user?.token || null
  }, [isTokenExpired, handleRefreshToken, user])

  return checkAndRefreshToken
}
